import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useNeuroMessages } from './MessageContext';
import RemoteSessionForm from './RemoteSessionForm';
import { notifySuccess } from './ToastNotifications';
import { Modal } from '../../neuro-ui';

const RemoteSessionModal = ({ className, closeBtn, isOpen, onClose }) => {
  const messageContext = useNeuroMessages();
  const classes = classnames(className, 'socialModal', 'remoteSessionModal');

  const onSessionCreateSuccess = () => {
    notifySuccess('remoteSession.created');
    onClose();
  };

  return (
    <Modal
      show={isOpen}
      className={classes}
      title={messageContext.getMessage('remoteSession.modal.title')}
      onClose={onClose}
      closeBtn={closeBtn}
      nodeId="root"
    >
      <RemoteSessionForm onSubmit={onSessionCreateSuccess} />
    </Modal>
  );
};
RemoteSessionModal.propTypes = {
  className: PropTypes.string,
  closeBtn: PropTypes.any,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default RemoteSessionModal;
